
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5Kzz3", function(module, exports) {

var $1z9oK = parcelRequire("1z9oK");

parcelRequire("gSgn8");

// This module acts as a live store for streamed SmartLink SSR batch data.
let $eee01957e7d1c366$var$storeState = {};
let $eee01957e7d1c366$var$boundaryMap = {};
const $eee01957e7d1c366$export$f2cf2e0cbb71e3f2 = (data)=>{
    Object.assign($eee01957e7d1c366$var$storeState, data);
};
const $eee01957e7d1c366$export$47351e79b7de3fbe = ()=>{
    return $eee01957e7d1c366$var$storeState;
};
const $eee01957e7d1c366$export$329d1a84b16e6bb = (data)=>{
    Object.assign($eee01957e7d1c366$var$boundaryMap, data);
};
const $eee01957e7d1c366$export$b0766f9270a6fd3 = ()=>{
    return $eee01957e7d1c366$var$boundaryMap;
};
const $eee01957e7d1c366$export$3ec3b3524523ef23 = ()=>{
    $eee01957e7d1c366$var$storeState = {};
    $eee01957e7d1c366$var$boundaryMap = {};
};
{
    const dataStream = (0, $1z9oK.getClientStream)('smartlinks');
    dataStream.addListener((batchData)=>{
        Object.assign($eee01957e7d1c366$var$storeState, batchData);
    });
    const boundaryStream = (0, $1z9oK.getClientStream)('smartlinks-boundary-map');
    boundaryStream.addListener((mapData)=>{
        Object.assign($eee01957e7d1c366$var$boundaryMap, mapData);
    });
}module.exports["updateSSRSmartLinksStore"] = $eee01957e7d1c366$export$f2cf2e0cbb71e3f2;
module.exports["getSSRSmartLinksStore"] = $eee01957e7d1c366$export$47351e79b7de3fbe;
module.exports["updateSSRSmartLinksBoundaryMap"] = $eee01957e7d1c366$export$329d1a84b16e6bb;
module.exports["getSSRSmartLinksBoundaryMap"] = $eee01957e7d1c366$export$b0766f9270a6fd3;
module.exports["resetSSRSmartLinksStore"] = $eee01957e7d1c366$export$3ec3b3524523ef23;

});

parcelRegister("9ImuD", function(module, exports) {

























const $efd7e121efbbc6f0$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("5Ndvb"));
        case 'da-DK':
            return (parcelRequire("iiIXH"));
        case 'de-DE':
            return (parcelRequire("2Tsxu"));
        case 'en-US':
            return (parcelRequire("kcHy2"));
        case 'en-GB':
            return (parcelRequire("itcXa"));
        case 'en-ZZ':
            return (parcelRequire("gchso"));
        case 'es-ES':
            return (parcelRequire("96L2T"));
        case 'fi-FI':
            return (parcelRequire("jaVup"));
        case 'fr-FR':
            return (parcelRequire("97KoO"));
        case 'hu-HU':
            return (parcelRequire("8lubX"));
        case 'it-IT':
            return (parcelRequire("eNKAp"));
        case 'ja-JP':
            return (parcelRequire("eVHt2"));
        case 'ko-KR':
            return (parcelRequire("9l54B"));
        case 'no-NO':
            return (parcelRequire("9lkMC"));
        case 'nl-NL':
            return (parcelRequire("7m1Mp"));
        case 'pl-PL':
            return (parcelRequire("fGUyM"));
        case 'pt-BR':
            return (parcelRequire("4jTFc"));
        case 'ru-RU':
            return (parcelRequire("aHFLL"));
        case 'sv-SE':
            return (parcelRequire("iNU9J"));
        case 'tr-TR':
            return (parcelRequire("iHxcT"));
        case 'th-TH':
            return (parcelRequire("bhuCG"));
        case 'uk-UA':
            return (parcelRequire("lLUi2"));
        case 'vi-VN':
            return (parcelRequire("fL5hj"));
        case 'zh-TW':
            return (parcelRequire("fpOoD"));
        case 'zh-CN':
            return (parcelRequire("ag1zA"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $efd7e121efbbc6f0$var$fetchTranslations = async (locale)=>{
    const module = await $efd7e121efbbc6f0$var$importTranslations(locale);
    return module.default;
};
var $efd7e121efbbc6f0$export$2e2bcd8739ae039 = $efd7e121efbbc6f0$var$fetchTranslations;
module.exports["default"] = $efd7e121efbbc6f0$export$2e2bcd8739ae039;

});

parcelRegister("5Ndvb", function(module, exports) {

let $437c00935acb14ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $437c00935acb14ea$var$load("i1TuF").then(()=>parcelRequire('1jUpD'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("iiIXH", function(module, exports) {

let $d52cc8f43585e630$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d52cc8f43585e630$var$load("eEPT4").then(()=>parcelRequire('jPcpM'));

});

parcelRegister("2Tsxu", function(module, exports) {

let $21b6db1ee7e67ba5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21b6db1ee7e67ba5$var$load("gkfGT").then(()=>parcelRequire('2HnQV'));

});

parcelRegister("kcHy2", function(module, exports) {

let $eb56b55f48170862$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eb56b55f48170862$var$load("6kSRw").then(()=>parcelRequire('9NBPE'));

});

parcelRegister("itcXa", function(module, exports) {

let $d724fbaf6f612dc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d724fbaf6f612dc2$var$load("2dFTF").then(()=>parcelRequire('hIkMa'));

});

parcelRegister("gchso", function(module, exports) {

let $bcab4eeeab7106ed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bcab4eeeab7106ed$var$load("auo6z").then(()=>parcelRequire('7hjEd'));

});

parcelRegister("96L2T", function(module, exports) {

let $6a192ae0f9ce7ae7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a192ae0f9ce7ae7$var$load("685rk").then(()=>parcelRequire('3knLh'));

});

parcelRegister("jaVup", function(module, exports) {

let $df5b8bb747e71066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df5b8bb747e71066$var$load("fp6pG").then(()=>parcelRequire('QPojr'));

});

parcelRegister("97KoO", function(module, exports) {

let $6a48c2662010f84a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a48c2662010f84a$var$load("6bt8l").then(()=>parcelRequire('lTPon'));

});

parcelRegister("8lubX", function(module, exports) {

let $6137b461e0c0d233$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6137b461e0c0d233$var$load("jjvsl").then(()=>parcelRequire('goIHn'));

});

parcelRegister("eNKAp", function(module, exports) {

let $ac69c757ef6ed44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ac69c757ef6ed44a$var$load("bAfbH").then(()=>parcelRequire('gwGzH'));

});

parcelRegister("eVHt2", function(module, exports) {

let $ade81b488ae26811$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ade81b488ae26811$var$load("5Q9X0").then(()=>parcelRequire('56b4I'));

});

parcelRegister("9l54B", function(module, exports) {

let $6cca02a75f916cfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cca02a75f916cfb$var$load("ePkyJ").then(()=>parcelRequire('69j0k'));

});

parcelRegister("9lkMC", function(module, exports) {

let $6cd63251145b2739$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cd63251145b2739$var$load("hpdFn").then(()=>parcelRequire('7suyn'));

});

parcelRegister("7m1Mp", function(module, exports) {

let $55abf7e453b9933f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55abf7e453b9933f$var$load("8qW90").then(()=>parcelRequire('1l5oU'));

});

parcelRegister("fGUyM", function(module, exports) {

let $b6c6a6ea694df539$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6c6a6ea694df539$var$load("a1OSV").then(()=>parcelRequire('7azO9'));

});

parcelRegister("4jTFc", function(module, exports) {

let $32541d63110b786f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $32541d63110b786f$var$load("8AvOI").then(()=>parcelRequire('cqo8f'));

});

parcelRegister("aHFLL", function(module, exports) {

let $7cae5214955aa781$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7cae5214955aa781$var$load("jxu37").then(()=>parcelRequire('2ob2Z'));

});

parcelRegister("iNU9J", function(module, exports) {

let $db085cfb205ba45c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db085cfb205ba45c$var$load("10YQF").then(()=>parcelRequire('6bYmv'));

});

parcelRegister("iHxcT", function(module, exports) {

let $d9d6005709d91a65$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9d6005709d91a65$var$load("daBgp").then(()=>parcelRequire('eURXY'));

});

parcelRegister("bhuCG", function(module, exports) {

let $8369094a4603e1c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8369094a4603e1c8$var$load("bI6N0").then(()=>parcelRequire('evqpq'));

});

parcelRegister("lLUi2", function(module, exports) {

let $fd99a6c46b5179db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd99a6c46b5179db$var$load("3Qhls").then(()=>parcelRequire('3uadp'));

});

parcelRegister("fL5hj", function(module, exports) {

let $b78f56f44c93f165$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b78f56f44c93f165$var$load("dgXIC").then(()=>parcelRequire('1Aznz'));

});

parcelRegister("fpOoD", function(module, exports) {

let $b39048758b7c76b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b39048758b7c76b0$var$load("jh4hi").then(()=>parcelRequire('am6cJ'));

});

parcelRegister("ag1zA", function(module, exports) {

let $777c9e58e5d8ad11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $777c9e58e5d8ad11$var$load("2AL0H").then(()=>parcelRequire('5vTPX'));

});

parcelRegister("6M71K", function(module, exports) {
/**
 * @generated SignedSource<<1066d6efd786ce5430f1beda32adf547>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecbb6e526a968754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$ecbb6e526a968754$var$node.hash = "f4093e7916c35c0c1b9141fd35c3dbe3";
var $ecbb6e526a968754$export$2e2bcd8739ae039 = $ecbb6e526a968754$var$node;


/**
 * @generated SignedSource<<d3539421d3fde47cae071bf203917b58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2114907496ee9554$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$2114907496ee9554$var$node.hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";
var $2114907496ee9554$export$2e2bcd8739ae039 = $2114907496ee9554$var$node;


/**
 * @generated SignedSource<<15994f0b375cf2c56b3f0388225172c9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $896ad30c32f2cdd3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$896ad30c32f2cdd3$var$node.hash = "05d2a2275047024b0d469ae534b88e41";
var $896ad30c32f2cdd3$export$2e2bcd8739ae039 = $896ad30c32f2cdd3$var$node;


/**
 * @generated SignedSource<<02c1e8cf13fe78a7350293e793c80f09>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5fd779f9cf97f4fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderCurrentSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$5fd779f9cf97f4fb$var$node.hash = "24af67d646910e1784019b6a037f34e4";
var $5fd779f9cf97f4fb$export$2e2bcd8739ae039 = $5fd779f9cf97f4fb$var$node;



var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7bZ3i = parcelRequire("7bZ3i");


var $1I43V = parcelRequire("1I43V");


var $a2xFu = parcelRequire("a2xFu");

const $89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $89aa0ef6b16bedeb$export$97f4c254b641e719 = (hostname)=>!$89aa0ef6b16bedeb$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $89aa0ef6b16bedeb$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $89aa0ef6b16bedeb$export$280e79c794cf814e = (url)=>$89aa0ef6b16bedeb$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $89aa0ef6b16bedeb$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $a2xFu.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $89aa0ef6b16bedeb$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $89aa0ef6b16bedeb$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$89aa0ef6b16bedeb$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};



var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");





var $6JLuV = parcelRequire("6JLuV");

const $7ac1c4b85cd786d3$export$d48d5704d1181ce6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    let t0;
    let t1;
    if ($[0] !== open) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                const { payload: payload } = event.data;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                if (payload?.url) open(payload);
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            open
        ];
        $[0] = open;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return null;
} : ()=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    // Listen for messages from iframes to open preview panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { payload: payload } = event.data;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            if (payload?.url) open(payload);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        open
    ]);
    return null;
};






var $27fJD = parcelRequire("27fJD");


var $cEgMD = parcelRequire("cEgMD");


var $e4o8D = parcelRequire("e4o8D");


var $l3tKl = parcelRequire("l3tKl");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");




var $egwA4 = parcelRequire("egwA4");


var $k00oi = parcelRequire("k00oi");


var $btw9C = parcelRequire("btw9C");


var $6GQtz = parcelRequire("6GQtz");




const $de526bdbda89b480$var$deferIdle = (cb)=>{
    if ('requestIdleCallback' in window) requestIdleCallback(cb, {
        timeout: 5000
    });
    else requestAnimationFrame(cb);
};
class $de526bdbda89b480$export$385f1396b754ac80 extends (0, $k00oi.default) {
    // Called once per page load
    prefetchData(url) {
        return super.prefetchData(url).then((data)=>{
            // Using deferIdle(requestIdleCallback) to ensure our onResolve callback doesn't interrupt the smart card client.
            // This means there's a chance under heavy browser load that the delay between client (pre)fetch and onResolve invocation will be >1s, but usually it shouldn't be.
            // Given the data schema is unstable, we're setting the type as unknown and expecting individual resolvers to be mindful.
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called on load and on click of each smart card link
    async fetchData(url, force) {
        if (!force || // Exposure needs to fire regardless of whether the url is in cache
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) && this.smartCardLocalCacheClient?.isUrlInCache(url)) return this.editorCardProvider.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
        return super.fetchData(url, force).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    constructor(props){
        const { onResolve: onResolve, envKey: envKey } = props;
        super(envKey);
        this.onResolve = void 0;
        this.editorCardProvider = void 0;
        // When cleaning up platform_editor_smartlink_local_cache, remove ? here and in other places in this file
        this.smartCardLocalCacheClient = void 0;
        this.getInitialCardStoreFromCache = ()=>{
            const initialStateCardStore = {};
            const cachedData = this.smartCardLocalCacheClient?.getCache() ?? {};
            Object.entries(cachedData).forEach(([url, value])=>{
                const details = value.data;
                if ((0, $6mKj3.expValEquals)('platform_sl_fix_cache_unresolved', 'isEnabled', true)) {
                    // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
                    const status = details && details.meta ? (0, $btw9C.getStatus)(details) : undefined;
                    if (status === 'resolved') initialStateCardStore[url] = {
                        status: status,
                        details: details,
                        metadataStatus: 'resolved'
                    };
                } else initialStateCardStore[url] = {
                    status: (0, $btw9C.getStatus)(details),
                    details: details,
                    metadataStatus: 'resolved'
                };
            });
            return initialStateCardStore;
        };
        this.onResolve = onResolve;
        // Because Card components uses data from client and it's super hard to pass ConfluenceEditorCardProvider to them,
        // we will create a new ConfluenceEditorCardProvider instance here and use it for SSR support.
        this.editorCardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)(this.envKey, this.baseUrlOverride);
        if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) this.smartCardLocalCacheClient = (0, $egwA4.SmartCardLocalCacheClient).getInstance();
        else this.smartCardLocalCacheClient = undefined;
        // Fire a client-side exposure for the SSR preload experiment. The experiment is only
        // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
        // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
        // point where the SSR-preloaded data is consumed on the client — ensures every page load
        // records an exposure, allowing us to measure the experiment's effect accurately.
        // Once the optimal value is found, this will be converted to a permanent Statsig config.
        (0, $6mKj3.manuallyLogExpExposure)('cc_editor_node_data_providers_preload_config');
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[this.editorCardProvider.name];
        this.editorCardProvider.setSSRData(ssrData);
    }
}



var $9sGCn = parcelRequire("9sGCn");

const $901e3ce3ee925fd9$var$getContentIdFromResolvedData = (resolvedData)=>{
    const ari = resolvedData.data['atlassian:ari'];
    return ari?.substring?.(ari?.lastIndexOf?.('/') + 1);
};
// data.data['@type'] will have two elements, for example ['schema:DigitalDocument', 'Document'], where 'schema:DigitalDocument' specifically denotes a live doc
// The resolve logic doesn't consistently position these two elements in the @type array, so the schema we need to validate may be in the 0th or 1st element
const $901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc = (resolvedData)=>{
    const typeArr = resolvedData.data['@type'];
    const isLiveDoc = typeArr?.[0] === 'schema:DigitalDocument' || typeArr?.[1] === 'schema:DigitalDocument';
    const isArchived = resolvedData.data['atlassian:state'] === 'archived';
    return isLiveDoc && !isArchived;
};
const $901e3ce3ee925fd9$var$isResolvedDataValid = (resolvedData)=>{
    if (!resolvedData || typeof resolvedData !== 'object') return false;
    const data = resolvedData.data;
    const meta = resolvedData.meta;
    if (!data || !meta) return false;
    if (!('@context' in data)) return false;
    const type = data['@type'];
    if (typeof type !== 'string' && !Array.isArray(type)) return false;
    return true;
};
let $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = false;
const $901e3ce3ee925fd9$export$e1f1443d16a1c263 = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, resolvedData)=>{
    if ($901e3ce3ee925fd9$var$isResolvedDataValid(resolvedData)) {
        if ($901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc(resolvedData)) {
            const contentId = $901e3ce3ee925fd9$var$getContentIdFromResolvedData(resolvedData);
            if (contentId) {
                let existingCachedData;
                try {
                    existingCachedData = readFragmentInterop({
                        id: `Content:${contentId}`
                    });
                } catch  {
                // readFragment throws an error if no data is found
                }
                // Reads are cheaper than writes, so only write if we don't already have the correct data in cache.
                if (!existingCachedData || existingCachedData?.subType !== 'live' || existingCachedData?.status !== 'current') {
                    writeFragmentInterop({
                        fragmentId: `Content:${contentId}`,
                        // status is current if we are an unarchived live doc
                        data: {
                            __typename: 'Content',
                            id: contentId,
                            subType: 'live',
                            status: 'current'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        }
    } else // If resolved data schema is invalid, we likely need to update it ASAP as Linking Platform's content resolver service API may have changed
    if (!$901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'invalidResolverData',
                actionSubject: 'liveDocSmartCardResolver',
                source: 'confluenceSmartCardProvider'
            }
        }).fire();
        // Only send this event once per load to reduce load on analytics pipeline
        $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = true;
    }
};


// Only log first error to console, to prevent spamming console with resolver errors
let $3c75c8f77ed4b940$var$hasLoggedResolverError = false;
const $3c75c8f77ed4b940$var$defaultConfluenceResolveHandler = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)=>{
    try {
        // NOTE FOR DEVS OF RESOLVERS: The `data` object comes from linking platform's content resolver service which is an UNSTABLE API SCHEMA.
        // Ensure your resolver logic handles invalid schemas gracefully and is able to notify your team if the schema changes and your code needs to be updated.
        (0, $901e3ce3ee925fd9$export$e1f1443d16a1c263)(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data);
    } catch (resolverError) {
        // prevent errors from causing smart card provider issues
        if (!$3c75c8f77ed4b940$var$hasLoggedResolverError) {
            const logger = (0, $7W8i8.getLogger)('ConfluenceSmartCardProvider');
            logger.error`resolver error: ${resolverError}`;
            $3c75c8f77ed4b940$var$hasLoggedResolverError = true;
        }
    }
};
const $3c75c8f77ed4b940$var$computeInitialStateFromCache = (smartCardClient)=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true)) // On page transition create the initial CardStore from Cache
    return !(0, $i6Ps3.isPageSSRd)() && smartCardClient instanceof (0, $de526bdbda89b480$export$385f1396b754ac80) ? smartCardClient.getInitialCardStoreFromCache() : null;
    else return null;
};
const $3c75c8f77ed4b940$var$CurrentSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { children: children, ...restProps } = props;
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5fd779f9cf97f4fb$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/smart-card-provider"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $896ad30c32f2cdd3$export$2e2bcd8739ae039),
        fragmentSpec: (0, $896ad30c32f2cdd3$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/smart-card-provider"
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>restProps?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        restProps?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l3tKl.HydrationSafeComponent), {
        isEnabled: (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)
    }, children));
};
const $3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $2114907496ee9554$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/smart-card-provider"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $ecbb6e526a968754$export$2e2bcd8739ae039),
        fragmentSpec: (0, $ecbb6e526a968754$export$2e2bcd8739ae039),
        __callerPackage__: "@confluence/smart-card-provider"
    });
    const smartCardClient = (0, $42omo.useMemo)(()=>props?.client || new (0, $de526bdbda89b480$export$385f1396b754ac80)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    const initialStateFromCache = (0, $42omo.useRef)($3c75c8f77ed4b940$var$computeInitialStateFromCache(smartCardClient));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { children: children, ...restProps } = props;
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? initialStateFromCache?.current ?? window['__SSR_SMARTLINKS__'] : window['__SSR_SMARTLINKS__'];
    const internalStoreOptions = (0, $btIEy.useStoreOptions)(initialState, isPageSSR);
    // Merge smartlink SSR data with any passed-in storeOptions (e.g. from shortcuts preloader)
    const presetInitialState = {
        ...internalStoreOptions,
        ...props.storeOptions ? {
            storeOptions: {
                ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false ? internalStoreOptions.storeOptions || {} : {},
                ...props.storeOptions,
                ...internalStoreOptions.storeOptions?.initialState && (0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {
                    initialState: {
                        ...internalStoreOptions.storeOptions.initialState,
                        ...props.storeOptions.initialState
                    }
                } : {}
            }
        } : {}
    };
    const shouldControlDataExport = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.PDF_EXPORT_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bZ3i.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        isPreviewPanelAvailable: restProps.isPreviewPanelAvailable,
        openPreviewPanel: restProps.openPreviewPanel,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? {} : presetInitialState,
        ...restProps,
        ...(0, $6mKj3.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) ? presetInitialState : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l3tKl.HydrationSafeComponent), {
        isEnabled: (0, $6mKj3.expVal)('confluence_smartlinks_suspense', 'isEnabled', false)
    }, children));
};
const $3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider = (props)=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $42omo.useMemo)(()=>{
        if (!cloudId) return open;
        return ({ url: url, ari: ari, ...rest })=>open({
                url: (0, $89aa0ef6b16bedeb$export$193bb0d0d16ee7a7)(cloudId, url, ari),
                ari: ari,
                ...rest
            });
    }, [
        open,
        cloudId
    ]);
    const { children: children, doNotUsePreviewPanels: doNotUsePreviewPanels, ...restProps } = props;
    return (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || doNotUsePreviewPanels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, restProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, {
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        isPreviewPanelAvailable: renderServerPlaceholder ? (_ari)=>false : (0, $27fJD.isPreviewPanelAvailable),
        ...restProps
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ac1c4b85cd786d3$export$d48d5704d1181ce6), null));
};
const $3c75c8f77ed4b940$export$a56ebeb3c828cd38 = (props)=>{
    let updatedProps = props;
    const shouldPassRovoOptions = (0, $9wGTI.fg)('platform_sl_3p_auth_rovo_entitlement') || (0, $9wGTI.fg)('platform_sl_3p_auth_rovo_action_kill_switch') || (0, $9wGTI.fg)('rovogrowth-640-inline-action-nudge-fg');
    const useSessionDataGated = (0, $1I43V.functionUnionWithCondition)(()=>shouldPassRovoOptions, (0, $bQm3c.useSessionData), ()=>undefined);
    const sessionData = useSessionDataGated();
    updatedProps = (0, $42omo.useMemo)(()=>({
            ...props,
            ...shouldPassRovoOptions && !!sessionData && {
                rovoOptions: {
                    isRovoEnabled: sessionData?.isRovoEnabled ?? false,
                    isRovoLLMEnabled: sessionData?.isRovoLLMEnabled ?? false
                }
            } || {}
        }), [
        props,
        sessionData,
        shouldPassRovoOptions
    ]);
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) return (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider, updatedProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, updatedProps);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3c75c8f77ed4b940$var$CurrentSmartCardProvider, updatedProps);
};
module.exports["ConfluenceSmartCardProvider"] = $3c75c8f77ed4b940$export$a56ebeb3c828cd38;

});

parcelRegister("btIEy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $8zMP3 = parcelRequire("8zMP3");


var $l3tKl = parcelRequire("l3tKl");


var $5Kzz3 = parcelRequire("5Kzz3");

// Suspense wrapper to be passed to ADF Renderer
function $e1de24b738f0d933$var$SuspenseWrapperForUrl(t0) {
    const $ = (0, $frIzR.c)(6);
    const { url: url, children: children } = t0;
    if (!url || !(0, $6mKj3.expVal)("confluence_smartlinks_suspense", "isEnabled", false)) return children;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5Kzz3.getSSRSmartLinksBoundaryMap)();
        $[0] = t1;
    } else t1 = $[0];
    const boundaryMap = t1;
    const fetcherName = boundaryMap[url];
    if (!fetcherName) return children;
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l3tKl.HydrationSafeComponent), {
            isEnabled: true
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fetcherName || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: fetcherName
        }, t2);
        $[3] = fetcherName;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
}
const $e1de24b738f0d933$export$53d21446ea17fdf1 = (initialState, isPageSSRd, options)=>{
    const $ = (0, $frIzR.c)(8);
    options?.useSSRStore;
    let t0;
    if ($[0] !== initialState || $[1] !== options?.useSSRStore) {
        t0 = options?.useSSRStore ? (0, $5Kzz3.getSSRSmartLinksStore)() : initialState;
        $[0] = initialState;
        $[1] = options?.useSSRStore;
        $[2] = t0;
    } else t0 = $[2];
    const streamingStoreState = t0;
    let result;
    if ($[3] !== isPageSSRd || $[4] !== streamingStoreState) {
        result = {};
        if (isPageSSRd) result.SuspenseWrapperForUrl = $e1de24b738f0d933$var$SuspenseWrapperForUrl;
        if (streamingStoreState && (isPageSSRd || (0, $6mKj3.expValEquals)("platform_editor_smartlink_local_cache", "isEnabled", true))) {
            let t1;
            if ($[6] !== streamingStoreState) {
                t1 = {
                    initialState: streamingStoreState
                };
                $[6] = streamingStoreState;
                $[7] = t1;
            } else t1 = $[7];
            result.storeOptions = t1;
        }
        $[3] = isPageSSRd;
        $[4] = streamingStoreState;
        $[5] = result;
    } else result = $[5];
    return result;
};
module.exports["useStoreOptions"] = $e1de24b738f0d933$export$53d21446ea17fdf1;

});

parcelRegister("l3tKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e4o8D = parcelRequire("e4o8D");

const $53e580037f471881$var$HydrationSafeComponentContent = /*#__PURE__*/ (0, $42omo.memo)(function HydrationSafeComponentContent({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $53e580037f471881$export$fc846b1429069eec({ children: children, isEnabled: isEnabled = true }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($53e580037f471881$var$HydrationSafeComponentContent, {
        isLocked: renderServerPlaceholder
    }, children);
}
module.exports["HydrationSafeComponent"] = $53e580037f471881$export$fc846b1429069eec;

});

parcelRegister("i6Ps3", function(module, exports) {
// Returns true on SSR and SPA if page was SSR'd
const $70ad96d323d38e4d$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(window.__SSR_RENDERED__);
};
module.exports["isPageSSRd"] = $70ad96d323d38e4d$export$a8c2f05884e8c7a1;

});

parcelRegister("6JLuV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eIleF = parcelRequire("eIleF");


var $k4HRJ = parcelRequire("k4HRJ");

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $dj7jL = parcelRequire("dj7jL");

var $1DfVr = parcelRequire("1DfVr");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irOoi = parcelRequire("irOoi");


var $fwXBL = parcelRequire("fwXBL");


var $gJsgh = parcelRequire("gJsgh");


var $8jHAi = parcelRequire("8jHAi");


var $bVHZY = parcelRequire("bVHZY");


var $1dKyn = parcelRequire("1dKyn");


var $ZDq1z = parcelRequire("ZDq1z");


var $2qVkt = parcelRequire("2qVkt");


var $7ZcJJ = parcelRequire("7ZcJJ");


var $dh538 = parcelRequire("dh538");





var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $1aa2596c972dea88$export$a50c261b4b52f403 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("io4wE"))), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});



var $4TXTZ = parcelRequire("4TXTZ");


var $1tWfF = parcelRequire("1tWfF");


var $lEONG = parcelRequire("lEONG");








var $2JrHF = parcelRequire("2JrHF");

const $e28b38e9ce90a1b0$var$fetchPolicy = 'network-only';

const $e28b38e9ce90a1b0$var$atlasGoalEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("bRKPZ")), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-goal-panel-opened');
        const siteId = (0, $lEONG.getSiteId)('goal', ari);
        const queryContext = siteId ? (0, $1tWfF.createPlatformSiteAri)(siteId) : null;
        return {
            queries: {
                queryReference: {
                    parameters: $2JrHF.default,
                    variables: {
                        ari: ari,
                        queryContext: queryContext
                    },
                    options: {
                        fetchPolicy: $e28b38e9ce90a1b0$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $e28b38e9ce90a1b0$export$2e2bcd8739ae039 = $e28b38e9ce90a1b0$var$atlasGoalEntryPoint;









const $34c41f4defcbf512$var$objectPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("gmZE4")), {
        moduleId: "bb3d75a4",
        priority: "interaction",
        moduleId: 'object-preview-panel-entrypoint'
    }),
    getPreloadProps: ({})=>({})
});
var $34c41f4defcbf512$export$2e2bcd8739ae039 = $34c41f4defcbf512$var$objectPreviewPanelEntryPoint;



var $4BDAe = parcelRequire("4BDAe");


var $c6GJD = parcelRequire("c6GJD");








var $1eBTN = parcelRequire("1eBTN");











var $fff9r = parcelRequire("fff9r");

const $c355941354246ac5$var$fetchPolicy = 'network-only';

const $c355941354246ac5$var$atlasProjectEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("9Ekya")), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $4TXTZ.default)('townsquare-project-panel-opened');
        // check for M0 or greater
        const isProjectNativeIntegrationEnabled = (0, $c6GJD.default).getExperimentValue('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0;
        const siteId = (0, $lEONG.getSiteId)('project', ari);
        const queryContext = siteId ? (0, $1tWfF.createPlatformSiteAri)(siteId) : null;
        const capabilitiesContainerId = siteId ? (0, $1eBTN.getSiteAri)(siteId) : '';
        return {
            queries: {
                queryReference: {
                    parameters: $fff9r.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled,
                        queryContext: queryContext,
                        capabilitiesContainerId: capabilitiesContainerId
                    },
                    options: {
                        fetchPolicy: $c355941354246ac5$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $c355941354246ac5$export$2e2bcd8739ae039 = $c355941354246ac5$var$atlasProjectEntryPoint;


/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $35e8e01797ae2575$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}



var $gWF6I = parcelRequire("gWF6I");








var $i84MD = parcelRequire("i84MD");

const $45efcf82695de5ad$var$fetchPolicy = 'network-only';

const $45efcf82695de5ad$var$teamPreviewPanelEntryPoint = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("jGzPz")), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $i84MD.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $45efcf82695de5ad$var$fetchPolicy
                    }
                }
            }
        })
});
var $45efcf82695de5ad$export$2e2bcd8739ae039 = $45efcf82695de5ad$var$teamPreviewPanelEntryPoint;


const $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];





const $721536e6a2e4576b$var$_default_1 = (0, $aXWIB.defineMessages)({
    workItem: {
        id: "navigation.preview-panel-global-objects.workItem",
        defaultMessage: "Jira work item"
    },
    project: {
        id: "navigation.preview-panel-global-objects.project",
        defaultMessage: "Project"
    },
    goal: {
        id: "navigation.preview-panel-global-objects.goal",
        defaultMessage: "Goal"
    },
    team: {
        id: "navigation.preview-panel-global-objects.team",
        defaultMessage: "Team"
    },
    page: {
        id: "navigation.preview-panel-global-objects.page",
        defaultMessage: "Confluence Page"
    },
    whiteboard: {
        id: "navigation.preview-panel-global-objects.whiteboard",
        defaultMessage: "Confluence Whiteboard"
    },
    object: {
        id: "navigation.preview-panel-global-objects.object",
        defaultMessage: "Assets Object"
    },
    loomVideo: {
        id: "navigation.preview-panel-global-objects.loomVideo",
        defaultMessage: "Loom Video"
    },
    loomVideoIcon: {
        id: "navigation.preview-panel-global-objects.loomVideoIcon",
        defaultMessage: "Loom Video Icon"
    }
});
var $721536e6a2e4576b$export$2e2bcd8739ae039 = $721536e6a2e4576b$var$_default_1;






var $48FEk = parcelRequire("48FEk");

/* ErrorFallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $ibFXh = parcelRequire("ibFXh");

var $aSy6D = parcelRequire("aSy6D");

var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");




var $8ca7114f2e83ff40$exports = {};
$8ca7114f2e83ff40$exports = new URL("ErrorGeneric.5fda5790.svg", import.meta.url).toString();





const $9e3978ea1fc35db1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorHeader: {
        id: "navigation.preview-panel-global-objects.panels.error-header",
        defaultMessage: "Can\u2019t load details"
    },
    errorDescription: {
        id: "navigation.preview-panel-global-objects.panels.error-description",
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>."
    }
});


const $a06bcd4811576243$var$styles = {
    body: "_bozgxncg _y4tixncg _1q511ejb _85i51ejb"
};
const $a06bcd4811576243$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ $42omo.createElement((0, $ibFXh.PreviewPanel), null, /*#__PURE__*/ $42omo.createElement((0, $3ZVni.PreviewPanelHeader), {
        onClose: close,
        url: url
    }, /*#__PURE__*/ $42omo.createElement((0, $3R2u2.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $42omo.createElement((0, $aSy6D.PreviewPanelBody), {
        styles: $a06bcd4811576243$var$styles.body
    }, /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
        header: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorHeader),
        description: formatMessage((0, $9e3978ea1fc35db1$export$defe85febe8b728c).errorDescription, {
            link: (chunks)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: "https://status.atlassian.com/"
                }, chunks)
        }),
        headingLevel: 2,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8ca7114f2e83ff40$exports)))
    })));
});


/* FallbackPreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");













const $6d87b0f37db700b5$var$styles = {
    body: "_zulppxbi _1e0c1txw _2lx21bp4 _16jlkb7n _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    skeleton: "_2rko12b0 _1e0c1txw _bfhkizff _4t3igktf",
    skeletonRow1: "_1bsb1osq",
    skeletonRow2: "_1bsb1nrf",
    skeletonRow3: "_1bsb1w8u",
    skeletonRow4: "_1bsbhwvj"
};
const $6d87b0f37db700b5$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    return /*#__PURE__*/ $42omo.createElement((0, $ibFXh.PreviewPanel), null, /*#__PURE__*/ $42omo.createElement((0, $3ZVni.PreviewPanelHeader), {
        onClose: close,
        url: url
    }, /*#__PURE__*/ $42omo.createElement((0, $3R2u2.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $42omo.createElement((0, $aSy6D.PreviewPanelBody), {
        styles: $6d87b0f37db700b5$var$styles.body
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow1
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow2
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow3
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow4
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow1
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow2
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow3
        ])
    }), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $6d87b0f37db700b5$var$styles.skeleton,
            $6d87b0f37db700b5$var$styles.skeletonRow4
        ])
    })));
});


const $1b27a03431ccc931$var$emptyEntryPointProps = {};
const $1b27a03431ccc931$export$2ace74dd551e05c1 = ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $1b27a03431ccc931$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6d87b0f37db700b5$export$97ea7ee86eec0667), globalObject),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a06bcd4811576243$export$9f31ac9d4b42e91c), globalObject),
        runtimeProps: runtimeProps
    });
};


/* IFramePreviewPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");





var $cOrQJ = parcelRequire("cOrQJ");




















const $57b48019462940b6$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $57b48019462940b6$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $57b48019462940b6$export$4e691bca3211cc2f = (url, supportedObjects, rootSourceScreen)=>{
    try {
        const urlObj = new URL(url);
        if ((0, $dh538.fg)('pol-21166-fix-404-on-jpd-preview')) {
            if ($57b48019462940b6$var$isJpdObject(urlObj)) return $57b48019462940b6$var$buildJpdEmbedUrl(urlObj);
        }
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        if (rootSourceScreen && (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) urlObj.searchParams.set('previewRootSourceScreen', rootSourceScreen);
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs
        if ((0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav')) {
            const encodedRootSource = rootSourceScreen ? `&previewRootSource=${encodeURIComponent(rootSourceScreen)}` : '';
            return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}${encodedRootSource}`;
        } else return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $57b48019462940b6$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $57b48019462940b6$var$isJpdObject = (urlObj)=>{
    return urlObj.pathname.includes('/jira/polaris/projects/');
};
const $57b48019462940b6$var$buildJpdEmbedUrl = (urlObj)=>{
    const ideaKey = urlObj.searchParams.get('selectedIssue');
    urlObj.searchParams.delete('selectedIssue');
    urlObj.pathname = `/browse/${ideaKey}/embed`;
    return urlObj.toString();
};


const $e0021b485e98a5e2$var$styles = {
    iframe: "_19itglyw _1bsb1osq _4t3i1osq",
    body: "_1e0c1txw _16jlkb7n _18m91wug"
};
const $e0021b485e98a5e2$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $e0021b485e98a5e2$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $42omo.memo)(({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes })=>{
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, $42omo.useState)();
    const cloudId = ari ?? $e0021b485e98a5e2$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient = new (0, $a9sR2.default)({
                product: product,
                env: (0, $57b48019462940b6$export$4acedbb0ac692186)(window.location.hostname),
                origin: (0, $5DUgU.originType).WEB
            });
            if (cloudId) analyticsClient?.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
            return analyticsClient;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $42omo.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url = new URL(iframeUrl, window.location.origin);
        url.searchParams.set('themeMode', colorMode);
        return url.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $ibFXh.PreviewPanel), null, /*#__PURE__*/ $42omo.createElement((0, $3ZVni.PreviewPanelHeader), {
        onClose: close,
        url: url,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient
    }, /*#__PURE__*/ $42omo.createElement((0, $3R2u2.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $42omo.createElement((0, $aSy6D.PreviewPanelBody), {
        styles: $e0021b485e98a5e2$var$styles.body,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient,
        ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
            analyticsAttributes: analyticsAttributes
        } : {}
    }, /*#__PURE__*/ $42omo.createElement("iframe", {
        src: iframeSrc,
        title: name,
        className: (0, $gMc0m.default)([
            $e0021b485e98a5e2$var$styles.iframe
        ])
    })));
});



const $a7dbab6e358b50cb$var$getGlobalObjectType = (ari)=>{
    const parsedAri = (0, $k4HRJ.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $a7dbab6e358b50cb$export$70bcacea0b970dee = (product, cloudId, options)=>{
    const { enabled: enabled = true, supportedObjects: supportedObjects = (0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251), analyticsAttributes: analyticsAttributes, rootSourceScreen: rootSourceScreen, environmentProvider: environmentProviderOverride } = options ?? {};
    const defaultEnvironmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const environmentProvider = environmentProviderOverride ?? defaultEnvironmentProvider;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { open: open } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $42omo.useCallback)(({ ari: ari })=>enabled && supportedObjects.includes($a7dbab6e358b50cb$var$getGlobalObjectType(ari)), [
        enabled,
        supportedObjects
    ]);
    const openPreviewPanel = (0, $42omo.useCallback)(({ url: url, ari: ari, name: name, parentProduct: parentProduct, panelData: panelData })=>{
        const globalObjectType = $a7dbab6e358b50cb$var$getGlobalObjectType(ari);
        if (!isPreviewPanelAvailable({
            ari: ari
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $57b48019462940b6$export$9f140ed41af5108c)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))) : (0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ)));
                const title = formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).workItem);
                panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0021b485e98a5e2$export$83f0623b6f97b032), {
                    name: title,
                    url: url,
                    iframeUrl: (0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects, rootSourceScreen) : (0, $57b48019462940b6$export$4e691bca3211cc2f)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari,
                    ...(0, $dh538.fg)('add_capacity_tab_to_the_board_horizontal_nav') ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                {
                    const teamEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $45efcf82695de5ad$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    const teamPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $45efcf82695de5ad$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: teamEntryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            ari: ari,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).team),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? teamPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, teamPanel);
                    panelProduct = 'people';
                    break;
                }
            case 'townsquare-goal':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $e28b38e9ce90a1b0$export$2e2bcd8739ae039), {
                        ari: ari
                    });
                    const goalPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $e28b38e9ce90a1b0$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).goal),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? goalPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, goalPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'townsquare-project':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $c355941354246ac5$export$2e2bcd8739ae039), {
                        ari: ari
                    });
                    const projectPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $c355941354246ac5$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $35e8e01797ae2575$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? projectPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, projectPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-page':
                {
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $2bcdee8d1b1c44c4$export$cec6f7cb9c99f251).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $1aa2596c972dea88$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $1aa2596c972dea88$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).page),
                            url: formattedUrl,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $1aa2596c972dea88$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $1aa2596c972dea88$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                {
                    const assetsEntryPointReference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $34c41f4defcbf512$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1b27a03431ccc931$export$2ace74dd551e05c1), {
                        entryPoint: (0, $34c41f4defcbf512$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: assetsEntryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            ari: ari,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        // These are fallback properties
                        globalObject: {
                            name: formatMessage((0, $721536e6a2e4576b$export$2e2bcd8739ae039).object),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwXBL))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'assetsPreviewPanel';
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct
            }
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        environmentProviderOverride,
        product,
        cloudId,
        analyticsAttributes,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
};
const $a7dbab6e358b50cb$var$isAllowedOrigin = (origin)=>{
    return origin === window.location.origin;
};
const $a7dbab6e358b50cb$export$3cfc2fe60a8f0a1c = (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $42omo.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Validate origin FIRST - reject messages from untrusted origins
            // Protected by feature flag: vuln-fix-adding-origin-validation-for-iframe-pp
            if (!$a7dbab6e358b50cb$var$isAllowedOrigin(event.origin) && (0, $dh538.fg)('vuln-fix-adding-origin-validation-for-iframe-pp')) return;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};



var $bQm3c = parcelRequire("bQm3c");


var $27fJD = parcelRequire("27fJD");


var $eToX6 = parcelRequire("eToX6");

/**
 * Resolves Confluence short links to canonical URLs for preview panels.
 * For Confluence short links (e.g., /wiki/x/ABC123), attempts to construct
 * the canonical URL from preview.href parameters.
 */ const $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl = (originalUrl, response)=>{
    const responseData = response?.data;
    const previewHref = responseData?.preview?.href;
    if (!previewHref) return originalUrl;
    try {
        const previewUrl = new URL(previewHref);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            return `https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`;
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
// Helper function to check if previewPanels query parameter is present
const $88a4e0a84f25d5c3$var$hasPreviewPanelsParam = ()=>{
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('previewPanels');
    } catch  {
        return false;
    }
};
const $88a4e0a84f25d5c3$var$noop = ()=>{
// this is intentional
};
const $88a4e0a84f25d5c3$export$b92594fec494137a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
        };
        $[0] = t0;
    } else t0 = $[0];
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, t0);
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    let t1;
    if ($[1] !== cardContext || $[2] !== openAtlasPreviewPanel || $[3] !== openConfluencePagePreviewPanel) {
        const open = (t2)=>{
            const { url: url, ari: ari, panelData: panelData } = t2;
            let resolvedUrl = url;
            if (url.includes("/wiki/x/") && cardContext?.value?.store) {
                const cardState = cardContext.value.store.getState()[url];
                if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
            }
            const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
            const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
            if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
                window.parent.postMessage({
                    type: "OPEN_PREVIEW_PANEL",
                    payload: {
                        url: resolvedUrl,
                        ari: ari,
                        name: formattedName,
                        panelData: panelData
                    }
                }, "*");
                return;
            }
            if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
                const urlObj = new URL(resolvedUrl);
                urlObj.searchParams.set("previewPanels", encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(",")));
                openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
                return;
            }
            if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Goal",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Project",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $b8JCF.JiraIssueAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Jira Work Item",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Team",
                    parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
        };
        t1 = {
            open: open
        };
        $[1] = cardContext;
        $[2] = openAtlasPreviewPanel;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $a7dbab6e358b50cb$export$70bcacea0b970dee)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId, {
        supportedObjects: (0, $27fJD.ALL_SUPPORTED_OBJECTS)
    });
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $1DfVr.useConfluencePagePreviewPanel)((0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $eIleF.useSmartCardContext)();
    const open = ({ url: url, ari: ari, panelData: panelData })=>{
        let resolvedUrl = url;
        // Only resolve when url is Confluence short links
        if (url.includes('/wiki/x/') && cardContext?.value?.store) {
            const cardState = cardContext.value.store.getState()[url];
            if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
        }
        const name = (0, $k4HRJ.AnyAri).parse(ari).resourceType;
        const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
        if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: resolvedUrl,
                    ari: ari,
                    name: formattedName,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        if ((0, $a2xFu.ConfluencePageAri).check(ari)) {
            const urlObj = new URL(resolvedUrl);
            urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $27fJD.ALL_SUPPORTED_OBJECTS).join(',')));
            openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
            return;
        }
        if ((0, $ixcaU.TownsquareGoalAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Goal',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $5JRMI.TownsquareProjectAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Project',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $b8JCF.JiraIssueAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Jira Work Item',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $eMqrF.IdentityTeamAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Team',
                parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
    };
    return {
        open: open
    };
};
module.exports["useOpenPreviewPanel"] = $88a4e0a84f25d5c3$export$b92594fec494137a;

});

parcelRegister("ixcaU", function(module, exports) {
// src/townsquare/goal/types.ts
var $c06d67ada792527e$export$947838268868cc57 = "townsquare", $c06d67ada792527e$export$935b9c2af9d62e80 = "goal";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/townsquare/goal/manifest.ts
var $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $c06d67ada792527e$export$947838268868cc57),
    resourceType: (0, $c06d67ada792527e$export$935b9c2af9d62e80),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d7e4c0c5e4ce08d0$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $d7e4c0c5e4ce08d0$export$e45ea1bd9a289a4f;

});

parcelRegister("dj7jL", function(module, exports) {
const $e6073c916b049162$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    HOME: 'home',
    JIRA: 'jira',
    TEAMS: 'teams'
};
module.exports["PARENT_PRODUCTS"] = $e6073c916b049162$export$bc4191f7b8dfa3a4;

});

parcelRegister("1DfVr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $io4wE = parcelRequire("io4wE");

const $af9c2f3d9e69f02f$export$46eb6ca3d43ca839 = (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $42omo.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io4wE.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $42omo.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $af9c2f3d9e69f02f$export$46eb6ca3d43ca839;

});

parcelRegister("io4wE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $8jHAi = parcelRequire("8jHAi");


var $cOrQJ = parcelRequire("cOrQJ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gdv5Z = parcelRequire("gdv5Z");


var $aqrhZ = parcelRequire("aqrhZ");


var $kFwgS = parcelRequire("kFwgS");

var $I1nNR = parcelRequire("I1nNR");

var $kudeD = parcelRequire("kudeD");


var $9ImuD = parcelRequire("9ImuD");

const $4a221c0892a490b0$var$styles = {
    fallback: "_1bsb1osq _4t3i1osq"
}; // @ts-ignore

const $4a221c0892a490b0$var$LazyEmbeddedConfluence = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("lAXlh")));
const $4a221c0892a490b0$export$c4789cfd0b0cd2c4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $9ImuD.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kudeD.PerformanceMetricsProvider), {
        contentType: props.mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
        sourceComponent: 'EmbeddedConfluence'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqrhZ.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $4a221c0892a490b0$var$styles.fallback
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a221c0892a490b0$var$LazyEmbeddedConfluence, props))));



var $ibFXh = parcelRequire("ibFXh");




var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");


var $b61pM = parcelRequire("b61pM");

const $1fc8fb56653d2345$export$b3bbf50939c515ce = ({ children: children, testId: testId })=>{
    if ((0, $dh538.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b61pM.PanelActionGroup), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        testId: testId,
        space: "space.050",
        alignBlock: "center"
    }, children);
};


var $aSy6D = parcelRequire("aSy6D");







var $lOzEN = parcelRequire("lOzEN");











var $c8wdn = parcelRequire("c8wdn");

function $e30361bf0d9a5c21$export$92b065b8b3b3301c({ onClick: onClick, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8wdn.PanelAction), {
        onClick: onClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        label: label || 'Expand panel'
    });
}



var $fZVub = parcelRequire("fZVub");


var $2os6v = parcelRequire("2os6v");

const $91e6116a3cc9352a$export$40b251582cb3e1fe = ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if ((0, $dh538.fg)('ads-panel-system-gpp')) {
        if (analyticsContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2os6v.PreviewPanelAction), {
            label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e30361bf0d9a5c21$export$92b065b8b3b3301c), {
            onClick: onClick,
            testId: testId,
            label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2os6v.PreviewPanelAction), {
        label: formatMessage((0, $fZVub.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOzEN))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};


var $3ZVni = parcelRequire("3ZVni");

var $3R2u2 = parcelRequire("3R2u2");


var $4BDAe = parcelRequire("4BDAe");




const $11543dd8ad4b06d3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});



var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");




var $3WsBD = parcelRequire("3WsBD");

const $8f94b4972688fbbf$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $8f94b4972688fbbf$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $5DUgU.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $5DUgU.envType).DEV;
    return (0, $5DUgU.envType).PROD;
};
const $8f94b4972688fbbf$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $8f94b4972688fbbf$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $a9sR2.default)({
        product: 'confluencePreviewPanel',
        env: $8f94b4972688fbbf$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $8f94b4972688fbbf$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $8f94b4972688fbbf$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $3WsBD.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $8f94b4972688fbbf$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $8f94b4972688fbbf$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};


const $178f91e075c3dc2a$var$styles = {
    body: "_16jlkb7n _18m915vq _ca0q1ejb _u5f31ejb _19bv1ejb"
};
const $178f91e075c3dc2a$export$a8a96573251792b1 = ({ url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $4BDAe.usePreviewPanelsActions)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const themeState = (0, $cOrQJ.default)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        setAnalyticsClient((0, $8f94b4972688fbbf$export$7d842b959fcdcd03)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $8f94b4972688fbbf$export$232fd46a0431e57a)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $42omo.useMemo)(()=>(0, $8f94b4972688fbbf$export$a639a54e55b70225)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    const embeddedConfluenceSource = (()=>{
        try {
            const urlObj = new URL(formattedUrl);
            return urlObj.searchParams.get('embeddedConfluenceSource');
        } catch  {
            return null;
        }
    })();
    const isProjectPagesUxRevampExpEnabled = (0, $c6GJD.default).getExperimentValue('project-pages-ux-revamp-experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const runtimeProps = {
        url: formattedUrl,
        showFooter: false,
        hasFooterLogo: false,
        onModeChange: onModeChange,
        onPublish: actions?.onPublish,
        allowedFeatures: panelData?.allowedFeatures,
        parentProduct: parentProduct,
        embeddedConfluenceSource: embeddedConfluenceSource && isProjectPagesUxRevampExpEnabled ? embeddedConfluenceSource : 'confluence-page-preview-panel',
        themeState: themeState
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibFXh.PreviewPanel), {
        testId: "confluence-preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3ZVni.PreviewPanelHeader), {
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: 'confluence-page',
        onClose: onClose,
        onOpenInNewTab: actions?.onOpenInNewTab,
        url: formattedUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3R2u2.PreviewPanelTitle), {
        title: formatMessage((0, $11543dd8ad4b06d3$export$defe85febe8b728c).pageTitle),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            label: "",
            size: "medium"
        })
    }), !!actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1fc8fb56653d2345$export$b3bbf50939c515ce), null, actions.onExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91e6116a3cc9352a$export$40b251582cb3e1fe), {
        onClick: actions.onExpand
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aSy6D.PreviewPanelBody), {
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: 'confluence-page',
        styles: $178f91e075c3dc2a$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4a221c0892a490b0$export$c4789cfd0b0cd2c4), runtimeProps)));
};
const $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent = ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, panelData: panelData } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($178f91e075c3dc2a$export$a8a96573251792b1, {
        url: url,
        parentProduct: parentProduct,
        cloudId: cloudId,
        panelData: panelData
    });
var $178f91e075c3dc2a$export$2e2bcd8739ae039 = $178f91e075c3dc2a$var$ConfluencePagePreviewPanelEntryPointComponent;
module.exports["ConfluencePagePreviewPanel"] = $178f91e075c3dc2a$export$a8a96573251792b1;
module.exports["default"] = $178f91e075c3dc2a$export$2e2bcd8739ae039;

});

parcelRegister("lAXlh", function(module, exports) {

let $fb8afde2bdda7769$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fb8afde2bdda7769$var$load("6iz6l"),
    $fb8afde2bdda7769$var$load("4SCW2"),
    $fb8afde2bdda7769$var$load("hhss7"),
    $fb8afde2bdda7769$var$load("kG8pF")
]).then(()=>parcelRequire('9bXIX'));

});

parcelRegister("1tWfF", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");

const $f5f10b203336bc8b$export$e1144f7c498cb0b0 = (siteId)=>{
    if (!siteId) return null;
    try {
        return (0, $d4Pk4.PlatformSiteAri).create({
            siteId: siteId
        }).toString();
    } catch  {
        return null;
    }
};
module.exports["createPlatformSiteAri"] = $f5f10b203336bc8b$export$e1144f7c498cb0b0;

});

parcelRegister("lEONG", function(module, exports) {

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");

var $9Omoq = parcelRequire("9Omoq");

function $5be5550e801954b4$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $ixcaU.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $5JRMI.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $9Omoq.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}
module.exports["getSiteId"] = $5be5550e801954b4$export$3ae2d1e732b25194;

});

parcelRegister("2JrHF", function(module, exports) {
/**
 * @generated SignedSource<<1ca4572c32089e7454e41aa8e6dcb853>>
 * @relayHash 5dede5e3396055ad2f125819b83632e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a74c9fbf1c7fa5af3997062753f5a9cf91cbd27629bb8e396a3352bcd33234e7
const $782e281f79312060$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "queryContext"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "url"
    }, v7 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "canEditMetrics"
    }, v11 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedGoals"
    }, v12 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v13 = {
        "kind": "ScalarField",
        "name": "canAddLinkedProjects"
    }, v14 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v15 = [
        v5 /*: any*/ ,
        v1 /*: any*/ 
    ], v16 = [
        v1 /*: any*/ 
    ], v17 = {
        "kind": "InlineFragment",
        "selections": v16 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = [
        v19 /*: any*/ 
    ], v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "messageId"
            },
            {
                "kind": "ScalarField",
                "name": "defaultValue"
            }
        ],
        "type": "TownsquareLocalizationField"
    }, v22 = {
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v20 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomName"
            },
            v21 /*: any*/ 
        ]
    }, v23 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v24 = {
        "kind": "LinkedField",
        "name": "namePlural",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v20 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomNamePlural"
            },
            v21 /*: any*/ 
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "kind"
    }, v26 = {
        "kind": "ScalarField",
        "name": "score"
    }, v27 = [
        v19 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v29 = {
        "kind": "ScalarField",
        "name": "scoringMode"
    }, v30 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v31 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v32 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v34 = {
        "kind": "ScalarField",
        "name": "type"
    }, v35 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v37 = {
        "kind": "ScalarField",
        "name": "archived"
    }, v38 = {
        "kind": "ScalarField",
        "name": "externalEntityId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "source"
    }, v40 = {
        "kind": "ScalarField",
        "name": "time"
    }, v41 = [
        v40 /*: any*/ ,
        v1 /*: any*/ 
    ], v42 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v43 = {
        "kind": "Literal",
        "name": "first",
        "value": 100
    }, v44 = [
        v43 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": [
                "TIME_ASC"
            ]
        }
    ], v45 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": v27 /*: any*/ 
    }, v46 = {
        "kind": "ScalarField",
        "name": "start"
    }, v47 = [
        {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "time",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareTargetDateRange",
                    "kind": "LinkedField",
                    "name": "dateRange",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ 
                    ]
                }
            ]
        },
        v19 /*: any*/ 
    ], v48 = {
        "kind": "ScalarField",
        "name": "variance"
    }, v49 = {
        "concreteType": "TownsquareMetric",
        "kind": "LinkedField",
        "name": "metric",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v34 /*: any*/ ,
            v36 /*: any*/ ,
            v37 /*: any*/ ,
            v38 /*: any*/ ,
            v39 /*: any*/ ,
            v42 /*: any*/ ,
            {
                "args": v44 /*: any*/ ,
                "concreteType": "TownsquareMetricValueConnection",
                "kind": "LinkedField",
                "name": "values",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v19 /*: any*/ ,
                                    v40 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "origin",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "TownsquareGoalUpdate",
                                                        "kind": "LinkedField",
                                                        "name": "goalUpdate",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "TownsquareGoal",
                                                                "kind": "LinkedField",
                                                                "name": "goal",
                                                                "plural": false,
                                                                "selections": v16 /*: any*/ 
                                                            },
                                                            v45 /*: any*/ ,
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ],
                                                "type": "TownsquareFromGoalUpdate"
                                            }
                                        ]
                                    },
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "args": v44 /*: any*/ ,
                        "concreteType": "TownsquareMetricValueConnection_extension",
                        "kind": "LinkedField",
                        "name": "values_extension",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "TownsquareMetricValueEdge_extension",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v41 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "TownsquareMetricTargetPeriod_extension",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriod",
                                        "plural": false,
                                        "selections": v47 /*: any*/ 
                                    },
                                    v48 /*: any*/ 
                                ]
                            }
                        ],
                        "storageKey": "values_extension(first:100,sort:[\"TIME_ASC\"])"
                    }
                ]
            }
        ]
    }, v50 = [
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ], v51 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "snapshotValue",
        "plural": false,
        "selections": v50 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "startValue"
    }, v53 = {
        "kind": "ScalarField",
        "name": "targetValue"
    }, v54 = [
        v19 /*: any*/ ,
        v40 /*: any*/ ,
        v1 /*: any*/ 
    ], v55 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "args": v44 /*: any*/ ,
                "concreteType": "TownsquareMetricTargetPeriodConnection_extension",
                "kind": "LinkedField",
                "name": "metricTargetPeriods_extension",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTargetPeriodEdge_extension",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "TownsquareMetricTargetPeriod_extension",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v47 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "latestValue",
                                "plural": false,
                                "selections": v54 /*: any*/ 
                            },
                            v48 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "metricTargetPeriods_extension(first:100,sort:[\"TIME_ASC\"])"
            }
        ]
    }, v56 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v1 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v57 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v34 /*: any*/ ,
                                    v36 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ ,
                                    v42 /*: any*/ 
                                ]
                            },
                            v51 /*: any*/ ,
                            v52 /*: any*/ ,
                            v53 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v58 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            v46 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v59 = [
        v58 /*: any*/ 
    ], v60 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "targetDate",
        "plural": false,
        "selections": v59 /*: any*/ 
    }, v61 = [
        v9 /*: any*/ ,
        v31 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v1 /*: any*/ 
    ], v62 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v63 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v64 = {
        "kind": "ScalarField",
        "name": "label"
    }, v65 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v66 = {
        "kind": "ScalarField",
        "name": "description"
    }, v67 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTownsquareHighlight"
    }, v68 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v2 /*: any*/ ,
        v31 /*: any*/ ,
        v1 /*: any*/ 
    ], v69 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v70 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v71 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v72 = [
        v63 /*: any*/ ,
        {
            "concreteType": "TownsquareGoalState",
            "kind": "LinkedField",
            "name": "newState",
            "plural": false,
            "selections": [
                v19 /*: any*/ ,
                v26 /*: any*/ ,
                v64 /*: any*/ 
            ]
        },
        v65 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": v61 /*: any*/ 
        },
        {
            "concreteType": "TownsquareUpdateNoteConnection",
            "kind": "LinkedField",
            "name": "updateNotes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "TownsquareUpdateNote",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v65 /*: any*/ ,
                                v66 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v1 /*: any*/ ,
                                v65 /*: any*/ ,
                                v66 /*: any*/ ,
                                v67 /*: any*/ ,
                                v69 /*: any*/ ,
                                v70 /*: any*/ ,
                                v63 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        v1 /*: any*/ 
    ], v73 = {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "latestUserUpdate",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v74 = {
        "kind": "ScalarField",
        "name": "missedUpdate"
    }, v75 = {
        "kind": "ScalarField",
        "name": "updateType"
    }, v76 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v77 = [
        {
            "concreteType": "TownsquareGoalUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v74 /*: any*/ ,
                        v75 /*: any*/ ,
                        v65 /*: any*/ ,
                        v76 /*: any*/ ,
                        v63 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ], v78 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 30
            }
        ],
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": v77 /*: any*/ ,
        "storageKey": "updates(first:30)"
    }, v79 = {
        "kind": "Literal",
        "name": "first",
        "value": 200
    }, v80 = [
        v79 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "tql",
            "value": "archived = false"
        }
    ], v81 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v82 = {
        "concreteType": "TownsquareProjectState",
        "kind": "LinkedField",
        "name": "state",
        "plural": false,
        "selections": v20 /*: any*/ 
    }, v83 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "dueDate",
        "plural": false,
        "selections": v59 /*: any*/ 
    }, v84 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v85 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v86 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v87 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v85 /*: any*/ ,
            v86 /*: any*/ 
        ]
    }, v88 = {
        "args": v80 /*: any*/ ,
        "filters": [
            "tql"
        ],
        "handle": "connection",
        "key": "GoalContentProjects_projects",
        "kind": "LinkedHandle",
        "name": "projects"
    }, v89 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v90 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v91 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v92 = {
        "args": v91 /*: any*/ ,
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": v77 /*: any*/ ,
        "storageKey": "updates(first:10)"
    }, v93 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v66 /*: any*/ 
    ], v94 = [
        v43 /*: any*/ 
    ], v95 = [
        v64 /*: any*/ ,
        v58 /*: any*/ 
    ], v96 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v31 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v76 /*: any*/ ,
                            v63 /*: any*/ 
                        ]
                    }
                ]
            },
            v18 /*: any*/ 
        ]
    }, v97 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v65 /*: any*/ ,
                v66 /*: any*/ ,
                v69 /*: any*/ ,
                v70 /*: any*/ ,
                v63 /*: any*/ ,
                v71 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v98 = [
        v79 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v4 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "args": v8 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalCustomFields"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalUpdateComposerCreate"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "goals_byId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        },
                        v7 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                v10 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                v11 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                },
                                v12 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedProjects"
                                },
                                v13 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddJiraAlignItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveJiraAlignItems"
                                }
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v2 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v15 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v15 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                }
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                v1 /*: any*/ ,
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "state"
                                        },
                                        v1 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v24 /*: any*/ 
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        },
                        v28 /*: any*/ ,
                        v29 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v30 /*: any*/ ,
                        v32 /*: any*/ ,
                        v35 /*: any*/ ,
                        {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                v53 /*: any*/ ,
                                                v55 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                },
                                                v37 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v78 /*: any*/ ,
                                                {
                                                    "args": v80 /*: any*/ ,
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        v82 /*: any*/ ,
                                                                        v83 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                },
                                                                v84 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        v87 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ],
                                                    "storageKey": "projects(first:200,tql:\"archived = false\")"
                                                },
                                                v88 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v89 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v90 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                v2 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetricTargetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTarget",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v6 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v92 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "successMeasures(first:50)"
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                v58 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v1 /*: any*/ ,
                                v35 /*: any*/ ,
                                v57 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareGoalCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ 
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v66 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v86 /*: any*/ ,
                                        v85 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareSlackConnectionConnection",
                            "kind": "LinkedField",
                            "name": "slackChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareSlackConnectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareSlackConnection",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareSlackChannel",
                                                    "kind": "LinkedField",
                                                    "name": "channel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numMembers"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
                            "kind": "LinkedField",
                            "name": "msteamsChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        v63 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v93 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v93 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v93 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v94 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isUser"
                                                                                },
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v84 /*: any*/ 
                                                                    ]
                                                                },
                                                                v87 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v94 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        {
                                                                            "args": v94 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v17 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v94 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v84 /*: any*/ 
                                                                    ]
                                                                },
                                                                v87 /*: any*/ ,
                                                                v18 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v94 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v37 /*: any*/ ,
                        {
                            "args": v91 /*: any*/ ,
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v65 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v63 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v1 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v71 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v36 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v39 /*: any*/ ,
                                                                                v42 /*: any*/ ,
                                                                                {
                                                                                    "args": [
                                                                                        v43 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "sort",
                                                                                            "value": [
                                                                                                "TIME_DESC"
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "TownsquareMetricValueConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricValueEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetricValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v54 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "newValue",
                                                                            "plural": false,
                                                                            "selections": v50 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newStartValue"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newTargetValue"
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "oldValue",
                                                                            "plural": false,
                                                                            "selections": v50 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalType",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalProgress",
                                                            "kind": "LinkedField",
                                                            "name": "progress",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v89 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "successMeasures",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v57 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v62 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v14 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareGoalType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "goalType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v22 /*: any*/ ,
                                                                                        v24 /*: any*/ ,
                                                                                        v23 /*: any*/ ,
                                                                                        v1 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                v92 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "successMeasures(first:50)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "subGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v37 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v56 /*: any*/ ,
                                                                                v57 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v62 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v78 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v91 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalUpdateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "updates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalUpdate",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v65 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "updateNotes",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareUpdateNote",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v65 /*: any*/ ,
                                                                                                        v66 /*: any*/ ,
                                                                                                        v1 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "updates(first:10)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareMetricTargetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "metricTargets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetricTarget",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetric",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metric",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v1 /*: any*/ ,
                                                                                        v37 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v1 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v1 /*: any*/ ,
                                                        v31 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v95 /*: any*/ 
                                                },
                                                {
                                                    "args": v89 /*: any*/ ,
                                                    "concreteType": "TownsquareGoalBundledUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "bundledUpdates",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalProgress",
                                                                            "kind": "LinkedField",
                                                                            "name": "progress",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v33 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": v72 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "nodeMissingReason"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v90 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v62 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "bundledUpdates(first:50)"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v1 /*: any*/ 
                                                    ]
                                                },
                                                v76 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v1 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v3 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v16 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v16 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        }
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                v96 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v27 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v95 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ],
                            "storageKey": "updates(first:10)"
                        },
                        v66 /*: any*/ ,
                        v96 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "args": v80 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v84 /*: any*/ ,
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v81 /*: any*/ ,
                                                v83 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v87 /*: any*/ ,
                                v18 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                        },
                        v88 /*: any*/ ,
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v97 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v97 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v97 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v98 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "workItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v65 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        v84 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                },
                                v87 /*: any*/ ,
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v98 /*: any*/ ,
                            "filters": [
                                "queryContext"
                            ],
                            "handle": "connection",
                            "key": "GoalContentJira_workItems",
                            "kind": "LinkedHandle",
                            "name": "workItems"
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "updateStreak_extension"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a74c9fbf1c7fa5af3997062753f5a9cf91cbd27629bb8e396a3352bcd33234e7",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$782e281f79312060$var$node.hash = "aff0ec12cadf172d9b6264d6e43003ad";
var $782e281f79312060$export$2e2bcd8739ae039 = $782e281f79312060$var$node;
module.exports["default"] = $782e281f79312060$export$2e2bcd8739ae039;

});

parcelRegister("bRKPZ", function(module, exports) {

let $8a38f9e50d59c988$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a38f9e50d59c988$var$load("h3ABO"),
    $8a38f9e50d59c988$var$load("bnExt"),
    $8a38f9e50d59c988$var$load("4cC8U"),
    $8a38f9e50d59c988$var$load("12Y92"),
    $8a38f9e50d59c988$var$load("eyJLy"),
    $8a38f9e50d59c988$var$load("6bVVs"),
    $8a38f9e50d59c988$var$load("7mo6o"),
    $8a38f9e50d59c988$var$load("9gVav"),
    $8a38f9e50d59c988$var$load("elrCw"),
    $8a38f9e50d59c988$var$load("7tgvK"),
    $8a38f9e50d59c988$var$load("iEUHW"),
    $8a38f9e50d59c988$var$load("2YffH"),
    $8a38f9e50d59c988$var$load("6wr18"),
    $8a38f9e50d59c988$var$load("47RmW"),
    $8a38f9e50d59c988$var$load("i1up4"),
    $8a38f9e50d59c988$var$load("6r6j2"),
    $8a38f9e50d59c988$var$load("c7Kmx"),
    $8a38f9e50d59c988$var$load("im1VN"),
    $8a38f9e50d59c988$var$load("gWJnq"),
    $8a38f9e50d59c988$var$load("9aYgD"),
    $8a38f9e50d59c988$var$load("7HuK4"),
    $8a38f9e50d59c988$var$load("16ESi"),
    $8a38f9e50d59c988$var$load("3EXzu"),
    $8a38f9e50d59c988$var$load("e4wOQ"),
    $8a38f9e50d59c988$var$load("iqTGf"),
    $8a38f9e50d59c988$var$load("hRqzw"),
    $8a38f9e50d59c988$var$load("cM6bW"),
    $8a38f9e50d59c988$var$load("khyhL"),
    $8a38f9e50d59c988$var$load("4ZJcE"),
    $8a38f9e50d59c988$var$load("JEQyV"),
    $8a38f9e50d59c988$var$load("jiK0X"),
    $8a38f9e50d59c988$var$load("lkOIY"),
    $8a38f9e50d59c988$var$load("93EyF"),
    $8a38f9e50d59c988$var$load("6EuUL"),
    $8a38f9e50d59c988$var$load("lbhYb"),
    $8a38f9e50d59c988$var$load("emINS"),
    $8a38f9e50d59c988$var$load("3BYXV"),
    $8a38f9e50d59c988$var$load("c251E"),
    $8a38f9e50d59c988$var$load("fZvb9"),
    $8a38f9e50d59c988$var$load("1w4HF"),
    $8a38f9e50d59c988$var$load("3bG25"),
    $8a38f9e50d59c988$var$load("kTth2"),
    $8a38f9e50d59c988$var$load("lTK3c"),
    $8a38f9e50d59c988$var$load("1WXdc"),
    $8a38f9e50d59c988$var$load("3GuOt"),
    $8a38f9e50d59c988$var$load("kzf0u"),
    $8a38f9e50d59c988$var$load("7BszR"),
    $8a38f9e50d59c988$var$load("8l20h"),
    $8a38f9e50d59c988$var$load("kHOMt"),
    $8a38f9e50d59c988$var$load("6iz6l"),
    $8a38f9e50d59c988$var$load("4SCW2"),
    $8a38f9e50d59c988$var$load("ffEVr"),
    $8a38f9e50d59c988$var$load("i0T1W"),
    $8a38f9e50d59c988$var$load("7t7nB"),
    $8a38f9e50d59c988$var$load("8MOeT"),
    $8a38f9e50d59c988$var$load("5sTNh"),
    $8a38f9e50d59c988$var$load("jOUAD"),
    $8a38f9e50d59c988$var$load("aXje8"),
    $8a38f9e50d59c988$var$load("36RFI"),
    $8a38f9e50d59c988$var$load("1SgRc"),
    $8a38f9e50d59c988$var$load("7EorR"),
    $8a38f9e50d59c988$var$load("hhss7"),
    $8a38f9e50d59c988$var$load("Wowvf"),
    $8a38f9e50d59c988$var$load("etEYy"),
    $8a38f9e50d59c988$var$load("aIokC")
]).then(()=>parcelRequire('jsjFl'));

});

parcelRegister("gmZE4", function(module, exports) {

let $beae84e6db069cf9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $beae84e6db069cf9$var$load("hyQJ6"),
    $beae84e6db069cf9$var$load("khyhL"),
    $beae84e6db069cf9$var$load("lTK3c"),
    $beae84e6db069cf9$var$load("1WXdc"),
    $beae84e6db069cf9$var$load("aXje8"),
    $beae84e6db069cf9$var$load("36RFI"),
    $beae84e6db069cf9$var$load("9gVav"),
    $beae84e6db069cf9$var$load("elrCw"),
    $beae84e6db069cf9$var$load("1SgRc"),
    $beae84e6db069cf9$var$load("f35QR"),
    $beae84e6db069cf9$var$load("eVYW1"),
    $beae84e6db069cf9$var$load("ls0Um"),
    $beae84e6db069cf9$var$load("020xd"),
    $beae84e6db069cf9$var$load("eTBsW"),
    $beae84e6db069cf9$var$load("bYxCZ"),
    $beae84e6db069cf9$var$load("6HBYC"),
    $beae84e6db069cf9$var$load("eDqo1"),
    $beae84e6db069cf9$var$load("1oiJ6"),
    $beae84e6db069cf9$var$load("huUvS"),
    $beae84e6db069cf9$var$load("1tzsM"),
    $beae84e6db069cf9$var$load("huORD"),
    $beae84e6db069cf9$var$load("e6e7M"),
    $beae84e6db069cf9$var$load("d5eE2"),
    $beae84e6db069cf9$var$load("lPQcc"),
    $beae84e6db069cf9$var$load("3L2tw"),
    $beae84e6db069cf9$var$load("gdwbX"),
    $beae84e6db069cf9$var$load("4S0zt"),
    $beae84e6db069cf9$var$load("8j9XC"),
    $beae84e6db069cf9$var$load("e4wOQ"),
    $beae84e6db069cf9$var$load("5pvpJ"),
    $beae84e6db069cf9$var$load("cM6bW"),
    $beae84e6db069cf9$var$load("iNa18"),
    $beae84e6db069cf9$var$load("lbhYb"),
    $beae84e6db069cf9$var$load("emINS"),
    $beae84e6db069cf9$var$load("3BYXV"),
    $beae84e6db069cf9$var$load("c251E"),
    $beae84e6db069cf9$var$load("gFEtJ"),
    $beae84e6db069cf9$var$load("gT8XU"),
    $beae84e6db069cf9$var$load("3GuOt"),
    $beae84e6db069cf9$var$load("8l20h"),
    $beae84e6db069cf9$var$load("iivLa"),
    $beae84e6db069cf9$var$load("6wr18"),
    $beae84e6db069cf9$var$load("dek7I"),
    $beae84e6db069cf9$var$load("jDjSj"),
    $beae84e6db069cf9$var$load("kHOMt"),
    $beae84e6db069cf9$var$load("ffEVr"),
    $beae84e6db069cf9$var$load("7TbZ2"),
    $beae84e6db069cf9$var$load("l22f4"),
    $beae84e6db069cf9$var$load("i0T1W"),
    $beae84e6db069cf9$var$load("7EorR"),
    $beae84e6db069cf9$var$load("hhss7"),
    $beae84e6db069cf9$var$load("Wowvf"),
    $beae84e6db069cf9$var$load("etEYy"),
    $beae84e6db069cf9$var$load("h3ABO"),
    $beae84e6db069cf9$var$load("1SiOe")
]).then(()=>parcelRequire('4bE2r'));

});

parcelRegister("fff9r", function(module, exports) {
/**
 * @generated SignedSource<<546f286904d22c6a4464152fdad8f147>>
 * @relayHash 86834ab46f611ced7b84eeaa508eb0cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 226cd3fd16613246c0626b066a390250e637fdbb467337bcbeacd4c1507311d2
const $4526c1a589f93175$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "capabilitiesContainerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isProjectNativeIntegrationEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "url"
    }, v10 = [
        v4 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v12 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v13 = [
        v12 /*: any*/ 
    ], v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = [
        v14 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v16 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "count"
    }, v19 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "canEditMetadata"
    }, v21 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v22 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v23 = {
        "kind": "ScalarField",
        "name": "light"
    }, v24 = {
        "kind": "ScalarField",
        "name": "description"
    }, v25 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v26 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v27 = {
        "kind": "ScalarField",
        "name": "key"
    }, v28 = {
        "kind": "ScalarField",
        "name": "value"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "start"
            },
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v32 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v9 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        v19 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v34 = [
        v27 /*: any*/ ,
        v4 /*: any*/ 
    ], v35 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "AppUser"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "CustomerUser"
    }, v39 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v40 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v39 /*: any*/ ,
                            v36 /*: any*/ 
                        ]
                    }
                ]
            },
            v19 /*: any*/ 
        ]
    }, v41 = [
        {
            "kind": "ScalarField",
            "name": "label"
        },
        v30 /*: any*/ 
    ], v42 = [
        {
            "alias": "projectValue",
            "kind": "ScalarField",
            "name": "value"
        }
    ], v43 = [
        v14 /*: any*/ ,
        v6 /*: any*/ ,
        v5 /*: any*/ ,
        v7 /*: any*/ ,
        v4 /*: any*/ 
    ], v44 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v43 /*: any*/ 
    }, v45 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v43 /*: any*/ 
    }, v46 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v47 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v31 /*: any*/ ,
                v24 /*: any*/ ,
                v44 /*: any*/ ,
                v45 /*: any*/ ,
                v36 /*: any*/ ,
                v46 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v48 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v24 /*: any*/ 
    ], v49 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v50 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v51 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedWorkItems"
    }, v53 = {
        "kind": "ScalarField",
        "name": "canAddLinkedWorkItems"
    }, v54 = {
        "kind": "ScalarField",
        "name": "webUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v8 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ ,
                            v9 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v10 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v10 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v11 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v13 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "args": v13 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectCustomFields"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "projects_byId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "capabilitiesContainerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProjectActionsContent_Capabilities"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v14 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v15 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v18 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v15 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "permission"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isVerified"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareProjectAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageAccess"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveProject"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        v27 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": v29 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUpdateNoteConnection",
                                    "kind": "LinkedField",
                                    "name": "updateNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v31 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v32 /*: any*/ 
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v34 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v34 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        v36 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v10 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedGoals"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnProject"
                                },
                                v21 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v29 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ 
                                                            ]
                                                        },
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectAccessConnection",
                            "kind": "LinkedField",
                            "name": "access",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectAccessEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "role"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "User",
                                                    "abstractKey": "__isUser"
                                                },
                                                v37 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v10 /*: any*/ ,
                                                    "type": "AtlassianAccountUser"
                                                },
                                                v38 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrivate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessLevel"
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v40 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v42 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v36 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ 
                                                                    ]
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v42 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v31 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v47 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v47 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v47 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v48 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v19 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v48 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v19 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v48 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v49 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v50 /*: any*/ 
                                                                    ]
                                                                },
                                                                v51 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v49 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v19 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v33 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "args": v49 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v4 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v49 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v50 /*: any*/ 
                                                                    ]
                                                                },
                                                                v51 /*: any*/ ,
                                                                v19 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v49 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v19 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v52 /*: any*/ ,
                                        v53 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        v12 /*: any*/ 
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v25 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v35 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v32 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v54 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v52 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "concreteType": "TownsquareProjectAppCapabilities",
                    "kind": "LinkedField",
                    "name": "projects_capabilities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canCreateProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "226cd3fd16613246c0626b066a390250e637fdbb467337bcbeacd4c1507311d2",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4526c1a589f93175$var$node.hash = "87e18379443cace437c0074df763a5f1";
var $4526c1a589f93175$export$2e2bcd8739ae039 = $4526c1a589f93175$var$node;
module.exports["default"] = $4526c1a589f93175$export$2e2bcd8739ae039;

});

parcelRegister("9Ekya", function(module, exports) {

let $7067ca4b7e284696$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7067ca4b7e284696$var$load("h3ABO"),
    $7067ca4b7e284696$var$load("bnExt"),
    $7067ca4b7e284696$var$load("4cC8U"),
    $7067ca4b7e284696$var$load("12Y92"),
    $7067ca4b7e284696$var$load("eyJLy"),
    $7067ca4b7e284696$var$load("6bVVs"),
    $7067ca4b7e284696$var$load("7mo6o"),
    $7067ca4b7e284696$var$load("9gVav"),
    $7067ca4b7e284696$var$load("elrCw"),
    $7067ca4b7e284696$var$load("7tgvK"),
    $7067ca4b7e284696$var$load("iEUHW"),
    $7067ca4b7e284696$var$load("2YffH"),
    $7067ca4b7e284696$var$load("6wr18"),
    $7067ca4b7e284696$var$load("bo7iw"),
    $7067ca4b7e284696$var$load("hyzoX"),
    $7067ca4b7e284696$var$load("47RmW"),
    $7067ca4b7e284696$var$load("i1up4"),
    $7067ca4b7e284696$var$load("6r6j2"),
    $7067ca4b7e284696$var$load("c7Kmx"),
    $7067ca4b7e284696$var$load("eBRUf"),
    $7067ca4b7e284696$var$load("im1VN"),
    $7067ca4b7e284696$var$load("gWJnq"),
    $7067ca4b7e284696$var$load("9aYgD"),
    $7067ca4b7e284696$var$load("7HuK4"),
    $7067ca4b7e284696$var$load("16ESi"),
    $7067ca4b7e284696$var$load("3EXzu"),
    $7067ca4b7e284696$var$load("lCT7Q"),
    $7067ca4b7e284696$var$load("e4wOQ"),
    $7067ca4b7e284696$var$load("iqTGf"),
    $7067ca4b7e284696$var$load("hRqzw"),
    $7067ca4b7e284696$var$load("cM6bW"),
    $7067ca4b7e284696$var$load("lkOIY"),
    $7067ca4b7e284696$var$load("93EyF"),
    $7067ca4b7e284696$var$load("6EuUL"),
    $7067ca4b7e284696$var$load("lbhYb"),
    $7067ca4b7e284696$var$load("emINS"),
    $7067ca4b7e284696$var$load("3BYXV"),
    $7067ca4b7e284696$var$load("c251E"),
    $7067ca4b7e284696$var$load("fZvb9"),
    $7067ca4b7e284696$var$load("1w4HF"),
    $7067ca4b7e284696$var$load("3bG25"),
    $7067ca4b7e284696$var$load("kTth2"),
    $7067ca4b7e284696$var$load("lTK3c"),
    $7067ca4b7e284696$var$load("1WXdc"),
    $7067ca4b7e284696$var$load("3GuOt"),
    $7067ca4b7e284696$var$load("kzf0u"),
    $7067ca4b7e284696$var$load("7BszR"),
    $7067ca4b7e284696$var$load("8l20h"),
    $7067ca4b7e284696$var$load("kHOMt"),
    $7067ca4b7e284696$var$load("6iz6l"),
    $7067ca4b7e284696$var$load("4SCW2"),
    $7067ca4b7e284696$var$load("ffEVr"),
    $7067ca4b7e284696$var$load("i0T1W"),
    $7067ca4b7e284696$var$load("7t7nB"),
    $7067ca4b7e284696$var$load("8MOeT"),
    $7067ca4b7e284696$var$load("5sTNh"),
    $7067ca4b7e284696$var$load("jOUAD"),
    $7067ca4b7e284696$var$load("aXje8"),
    $7067ca4b7e284696$var$load("36RFI"),
    $7067ca4b7e284696$var$load("1SgRc"),
    $7067ca4b7e284696$var$load("7EorR"),
    $7067ca4b7e284696$var$load("hhss7"),
    $7067ca4b7e284696$var$load("Wowvf"),
    $7067ca4b7e284696$var$load("etEYy"),
    $7067ca4b7e284696$var$load("aPnpL")
]).then(()=>parcelRequire('2WJhA'));

});

parcelRegister("i84MD", function(module, exports) {
/**
 * @generated SignedSource<<9d4fb102dc0f73a019fb6b88fd34feb8>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $b0e79b658ff3836d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0e79b658ff3836d$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $b0e79b658ff3836d$export$2e2bcd8739ae039 = $b0e79b658ff3836d$var$node;
module.exports["default"] = $b0e79b658ff3836d$export$2e2bcd8739ae039;

});

parcelRegister("jGzPz", function(module, exports) {

let $e54dbbd5e399344b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e54dbbd5e399344b$var$load("h6aIk"),
    $e54dbbd5e399344b$var$load("12Y92"),
    $e54dbbd5e399344b$var$load("eyJLy"),
    $e54dbbd5e399344b$var$load("6iz6l"),
    $e54dbbd5e399344b$var$load("4SCW2"),
    $e54dbbd5e399344b$var$load("9gVav"),
    $e54dbbd5e399344b$var$load("elrCw"),
    $e54dbbd5e399344b$var$load("izjuk"),
    $e54dbbd5e399344b$var$load("hZtKG"),
    $e54dbbd5e399344b$var$load("8rBWe"),
    $e54dbbd5e399344b$var$load("5WqHI"),
    $e54dbbd5e399344b$var$load("hyzoX"),
    $e54dbbd5e399344b$var$load("7EorR"),
    $e54dbbd5e399344b$var$load("hhss7"),
    $e54dbbd5e399344b$var$load("9SyhI"),
    $e54dbbd5e399344b$var$load("jRc59")
]).then(()=>parcelRequire('eK8NE'));

});

parcelRegister("27fJD", function(module, exports) {

var $a2xFu = parcelRequire("a2xFu");

var $eMqrF = parcelRequire("eMqrF");

var $b8JCF = parcelRequire("b8JCF");

var $ixcaU = parcelRequire("ixcaU");

var $5JRMI = parcelRequire("5JRMI");


var $eToX6 = parcelRequire("eToX6");

const $8d12b9c9b8a8c583$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project'
];
const $8d12b9c9b8a8c583$export$9e4592d635e5db5b = ({ ari: ari })=>{
    const href = window?.location?.href;
    if (href) {
        const searchParams = new URL(href).searchParams;
        if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') return false;
        if ((0, $eToX6.isInIframe)() && !(0, $eToX6.hasPreviewPanelIndicators)(searchParams)) return false;
    }
    if ((0, $a2xFu.ConfluencePageAri).check(ari)) return true;
    if ((0, $b8JCF.JiraIssueAri).check(ari)) return true;
    if ((0, $ixcaU.TownsquareGoalAri).check(ari)) return true;
    if ((0, $5JRMI.TownsquareProjectAri).check(ari)) return true;
    if ((0, $eMqrF.IdentityTeamAri).check(ari)) return true;
    return false;
};
module.exports["ALL_SUPPORTED_OBJECTS"] = $8d12b9c9b8a8c583$export$cec6f7cb9c99f251;
module.exports["isPreviewPanelAvailable"] = $8d12b9c9b8a8c583$export$9e4592d635e5db5b;

});


$parcel$global.rlb("fNa2t")
//# sourceMappingURL=FullPageEditorComponent.93549552.js.map
